import { ReactNode } from 'react'

import LinkButton from 'shared/ui/Button/LinkButton'
import FormattedText from 'shared/ui/FormattedText'

import OrderSteps from '../landings/Steps'

import {
  SectionCenterHeader,
  SectionWithPadding,
  StyledCustomPortableText
} from './styles'

import styles from './AboutUsOrderCycleSection.module.scss'

interface AboutUsOrderCycleSectionProps {
  header: string
  content: string | ReactNode
  steps: Array<string | ReactNode>
  cta: {
    text: string
    href: string
  }
}
export default function AboutUsOrderCycleSection({
  header,
  content,
  steps,
  cta
}: AboutUsOrderCycleSectionProps) {
  return (
    <SectionWithPadding
      className={styles.orderCycleSection}
      $size='large'
      $tablet
      $mobile={false}
      $condensed
    >
      <div className={styles.orderCycleContent}>
        <SectionCenterHeader>
          <strong>
            <FormattedText text={header} />
          </strong>
        </SectionCenterHeader>

        <StyledCustomPortableText>{content}</StyledCustomPortableText>
        <OrderSteps className={styles.orderCycleSteps} steps={steps} />

        <LinkButton href={cta.href} variant='primary' size='large'>
          {cta.text}
        </LinkButton>
      </div>
    </SectionWithPadding>
  )
}
